import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, DEFAULTNFTIMAGE } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";


const SuccessMint = (props) => {
    return (
       <Fragment>
        <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className='d-flex justify-content-center mt-5 mb-3'>
                                 <img className='justify-content-center' src="https://img.freepik.com/free-vector/hand-drawn-nft-style-ape-illustration_23-2149622021.jpg?size=338&ext=jpg&ga=GA1.1.1448711260.1707264000&semt=sph" alt="successNft" style={{width:"150px",height:"150px",borderRadius:'15px'}} />
                               
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                            <h1 className='d-flex justify-content-center' style={{fontSize:'40px'}}>Your item has been minted</h1>
                        </div>
                    </div>
                </div>
            </div>
        <Footer />
       </Fragment>
    );
}

export default SuccessMint;